// import React from "react";
// import PulseLoader from "react-spinners/PulseLoader";
// /**
//  * custum loader
//  * @returns
//  */
// export default function CustomSyncLoader() {
//   return <PulseLoader size={30} color={"#123abc"} />;
// }

import React from "react";

/**
 * It creates a custom loader that is used to show the user that the page is loading.
 * @returns A Dimmer and a Spinner.
 */
function CustomSyncLoader() {
  return (
    <div className="dimmer active">
      <div className="spinner4">
        <div className="bounce1" />
        <div className="bounce2" />
        <div className="bounce3" />
      </div>
    </div>
  );
}

export default CustomSyncLoader;
